
import React from 'react'

// eslint-disable-next-line react/display-name
export default () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
     <path d="M12 20L2 5h20z"/>
    </svg>
)